// extracted by mini-css-extract-plugin
module.exports = {"container":"avatar_container__efdHj"};